import style from './index.module.scss';

function SubMenu({ subMenu, currentPage }) {
    return (
        <ul className={style.subMenuBG}>
            {subMenu &&
                Object.values(subMenu).map((subMenuItem, id) => {
                    return (
                        <li style={{ width: '100%' }} key={id}>
                            <a
                                href={subMenuItem?.url === '#' ? undefined : subMenuItem.url}
                                className={style.subMenuItem}
                                style={subMenuItem.url === currentPage ? {textDecoration : "underline"} : {}}
                            >
                                {subMenuItem?.title}
                            </a>
                        </li>
                    );
                })}
        </ul>
    );
}

export default SubMenu;
